import {
  gql
} from "@apollo/client";

// type_id: 1-学生|2-军人|3-应急|4-医护
export const ADD_MILITARY_DISCOUNT = gql`
    mutation addDiscountInfo(
        $email: String!
        $firstname: String!
        $lastname: String!
        $image: String!
        $type_id: Int!
    ) {
        addDiscountInfo(
            input: {
                email: $email
                firstname: $firstname
                lastname: $lastname
                image: $image
                type_id: $type_id
            }
        ) {
            code
            message
            content
        }
    }
`;

export default {
  addMilitaryDiscountMutation: ADD_MILITARY_DISCOUNT
};
